export class Renderer {
  ctx: OffscreenCanvasRenderingContext2D;
  canvas: OffscreenCanvas;

  constructor(width: number, height: number) {
    this.canvas = new OffscreenCanvas(width, height);
    this.ctx = this.canvas.getContext("2d")!;
    this.ctx.font = "20px sans-serif";
  }

  async snapshot() {
    return {
      canvas: await this.canvas.convertToBlob(),
    };
  }

  async restore(snapshot: Awaited<ReturnType<typeof this.snapshot>>) {
    this.ctx.drawImage(
      await window.createImageBitmap(snapshot.canvas as Blob),
      0,
      0
    );
  }
}
